import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './home/home/home.component';
import { AuthenticationGuard } from '../core/guards/auth.guards';
import { PageNotFoundComponent } from '../shared/components/page-not-found/page-not-found/page-not-found.component';

const routes: Routes = [
  { path: 'home', component: HomeComponent, canActivate: [AuthenticationGuard] }

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})

export class BlocksRoutingModule { }